import { SearchParams } from '@/types/common'
import { PayloadSensor, SearchSensor, SensorUpdate } from '@/types/sensor'
import { queryStringify } from '@/ultils'
import axiosClient from '../axiosClient'

const sensorDataConfigApi = {
  getAll(searchParams: SearchSensor) {
    const url = '/api/sensor/weatherlink/sensors'
    return axiosClient.get(url + queryStringify(searchParams))
  },

  getListDetail(sensorId: number) {
    const url = `/api/sensor/get-detail/${sensorId}`
    return axiosClient.get(url)
  },

  getSoilMoistureDetail(sensorId: number) {
    const url = `/api/sensor/soil-moisture/${sensorId}`
    return axiosClient.get(url)
  },

  getListSoilMoisture(interfaceId: number, searchParams: SearchParams) {
    const url = `/api/sensor/${interfaceId}`
    return axiosClient.get(url + queryStringify(searchParams))
  },

  // Soil Moisture Sensor
  getSoilSensor(
    interfaceId: number,
    stationId?: number,
    searchParams?: SearchParams,
  ) {
    const url = `/api/sensor/${interfaceId}/soils`
    return axiosClient.get(url + queryStringify({ stationId, ...searchParams }))
  },

  getSoilSensorCis(interfaceId: number, address: number, ioId: number) {
    const url = `/api/sensor/${interfaceId}/soils/${address}/${ioId}`
    return axiosClient.get(url)
  },

  getSoilSensorId(
    interfaceId: number,
    sensorId: number,
    payload: PayloadSensor,
  ) {
    const url = `/api/sensor/${interfaceId}/soils/${sensorId}`
    return axiosClient.post(url, payload, {
      params: { stationId: payload.stationId },
    })
  },
  getLineUnit(interfaceId: number, address?: number) {
    const url = `/api/lineunit/${interfaceId}/${address}`
    return axiosClient.get(url)
  },
  getStationSiteSensor() {
    const url = `/api/weather/sync-station-site-sensor`
    return axiosClient.get(url)
  },
  getIoReading(interfaceId: number, address?: number, ioId?: number) {
    const url = `/api/lineunit/${interfaceId}/io/${address}/${ioId}`
    return axiosClient.get(url)
  },
  getListOtherSensor(interfaceId: number, stationId?: number) {
    const url = `/api/sensor/${interfaceId}/leafs${
      stationId ? `?stationId=${stationId}` : ''
    }`
    return axiosClient.get(url)
  },

  getListFlowSensor(searchParams: SearchSensor) {
    const url = `/api/pipe/pure/names`
    return axiosClient.get(url + queryStringify(searchParams))
  },

  getHistoryOtherSensor(
    interfaceId: number,
    sensorId: number,
    payload: PayloadSensor,
  ) {
    const url = `/api/sensor/${interfaceId}/leafs/${sensorId}`
    return axiosClient.post(url, payload)
  },
  exportCsvFlowSensor(data: { interfaceId: number; pipeIds: number[] }) {
    const url = `/api/v2/historylog/export-water-consumption`
    return axiosClient.post(url, data, {
      responseType: 'blob',
    })
  },

  exportCsvLeaf(
    interfaceId: number,
    data: {
      fromDate: string
      toDate: string
      sensorListIds: number[]
    },
  ) {
    const url = `/api/sensor/${interfaceId}/export/leaf`
    return axiosClient.post(url, data, {
      responseType: 'blob',
    })
  },
  exportCsvSoilMoisture(
    interfaceId: number,
    data: {
      fromDate: string
      toDate: string
      sensorListIds: number[]
    },
  ) {
    const url = `/api/sensor/${interfaceId}/export/soilmoisture`
    return axiosClient.post(url, data, {
      responseType: 'blob',
    })
  },
  update(payload: SensorUpdate) {
    const url = '/api/sensor'
    return axiosClient.put(url, payload)
  },
  updateSoilMoisture(payload: SensorUpdate) {
    const url = '/api/sensor/soil-moisture'
    return axiosClient.put(url, payload)
  },
}

export default sensorDataConfigApi
